import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="chat-scroll"
export default class extends Controller {
  connect() {
    // 1. Initial Load: Instant snap
    setTimeout(() => {
      this.scrollToTarget();
    }, 10);

    // 2. The Smart Observer
    this.observer = new MutationObserver((mutations) => {
      const hasNewMessages = mutations.some(
        (mutation) => mutation.addedNodes.length > 0,
      );

      if (hasNewMessages) {
        // Check if the user is within 150px of the bottom of the chat
        const isNearBottom =
          this.element.scrollHeight -
            this.element.scrollTop -
            this.element.clientHeight <
          150;

        // Only auto-scroll if they are already near the bottom!
        if (isNearBottom) {
          setTimeout(() => {
            this.scrollToBottom(true);
          }, 100);
        }
      }
    });

    this.observer.observe(this.element, { childList: true, subtree: true });
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  scrollToTarget() {
    const firstUnread = this.element.querySelector(".is-first-unread");
    if (firstUnread) {
      firstUnread.scrollIntoView({ behavior: "auto", block: "center" });
    } else {
      this.scrollToBottom(false);
    }
  }

  scrollToBottom(smooth = false) {
    // Relying strictly on the container's native smooth behavior now
    this.element.scrollTo({
      top: this.element.scrollHeight,
      behavior: smooth ? "smooth" : "auto",
    });
  }
}
